import type { Workflow } from '~/types/workflow.types';

// Published workflow — no open draft.
export const welcomeSeriesWorkflow: Workflow = {
    workflow_id: 'welcome_series',
    version: 1,
    status: 'published',
    published_at: '2026-05-01T00:00:00.000Z',
    deleted_at: null,
    updated_at: '2026-05-01T00:00:00.000Z',
    definition: {
        name: 'Welcome Series',
        description: 'Sends a welcome message to new subscribers',
        entry_trigger: { event_type: 'ContactCreated' },
        steps: [
            {
                step_id: 'step_1',
                type: 'send',
                message_key: 'welcome_message',
                campaign_subtype: 'marketing',
                safe_sending: true,
            },
            {
                step_id: 'step_2',
                type: 'mutate',
                target_path: 'contact.welcome_sent',
                value: true,
            },
        ],
    },
};

// Workflow with a published version and an open draft (v2 in progress).
export const helpRequestWorkflowPublished: Workflow = {
    workflow_id: 'help_request',
    version: 1,
    status: 'published',
    published_at: '2026-05-15T00:00:00.000Z',
    deleted_at: null,
    updated_at: '2026-05-15T00:00:00.000Z',
    definition: {
        name: 'Help Request Workflow',
        description: 'Responds to contacts requesting help',
        entry_trigger: { event_type: 'NewMessage' },
        steps: [
            {
                step_id: 'step_1',
                type: 'condition',
                condition_branches: [
                    {
                        id: 'branch_if',
                        logic: 'and',
                        target_step: 'step_2',
                        rules: [
                            {
                                id: 'rule_help_intent',
                                category: 'event',
                                field: 'event.payload.intent',
                                operator: 'equals',
                                value: 'HELP',
                            },
                        ],
                    },
                    { id: 'branch_else', logic: 'and', rules: [] },
                ],
            },
            {
                step_id: 'step_2',
                type: 'send',
                message_key: 'help_response',
                campaign_subtype: 'marketing',
                safe_sending: true,
            },
        ],
    },
};

export const helpRequestWorkflowDraft: Workflow = {
    workflow_id: 'help_request',
    version: 2,
    status: 'draft',
    published_at: null,
    deleted_at: null,
    updated_at: '2026-06-01T00:00:00.000Z',
    definition: {
        name: 'Help Request Workflow',
        description: 'Responds to contacts requesting help — adding tag step',
        entry_trigger: { event_type: 'NewMessage' },
        steps: [
            {
                step_id: 'step_1',
                type: 'condition',
                condition_branches: [
                    {
                        id: 'branch_if',
                        logic: 'and',
                        target_step: 'step_2',
                        rules: [
                            {
                                id: 'rule_help_intent',
                                category: 'event',
                                field: 'event.payload.intent',
                                operator: 'equals',
                                value: 'HELP',
                            },
                        ],
                    },
                    { id: 'branch_else', logic: 'and', rules: [] },
                ],
            },
            {
                step_id: 'step_2',
                type: 'send',
                message_key: 'help_response',
                campaign_subtype: 'marketing',
                safe_sending: true,
            },
            {
                step_id: 'step_3',
                type: 'mutate',
                target_path: 'contact.help_requested',
                value: true,
            },
        ],
    },
};

// Draft-only workflow — never published.
export const reEngagementWorkflow: Workflow = {
    workflow_id: 're_engagement',
    version: 1,
    status: 'draft',
    published_at: null,
    deleted_at: null,
    updated_at: '2026-06-05T00:00:00.000Z',
    definition: {
        name: 'Re-engagement Campaign',
        description: 'Targets contacts who have not engaged in 30 days',
        entry_trigger: { event_type: 'SegmentEntered' },
        steps: [
            {
                step_id: 'step_1',
                type: 'send',
                message_key: 'reengagement_offer',
                campaign_subtype: 'marketing',
                safe_sending: true,
            },
        ],
    },
};
